<template>
    <headboard></headboard>
    <div class="" style="padding-left:5%;padding-right:5%;">
        <div class="row">
        <div class="col-sm-8 text-center">

            <div class="row justify-content-center mt-5">
                <div class="col-lg-10 col-md-5 d-flex flex-column align-items-center justify-content-center">
                    <div class="row mt-5 ">
                        <div class="col-sm-12">
                            <img src="@/assets/images/logo.png" alt="" class="imgstar">
                        </div>
                    </div>

                    <div class="row mt-5">
                        <div class="col-sm-12 text-center">
                            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque
                                laudantium, totam
                                rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae
                                dicta sunt
                                explicabo.</p>
                        </div>
                    </div>
                </div>
            </div>



        </div>

        <div class="col-sm-4">
            <div class="row justify-content-center">
                <div class="col-lg-10 col-md-8 d-flex flex-column align-items-center justify-content-center">

                    <div class="card mb-3 mt-5">
                        <div class="card-body">
                            <!---------------------------------------------------------------------------------->
                            <div class="pt-4 pb-2">
                                <h5 class="card-title text-center pb-0 fs-4">Register</h5>
                            </div>
                            <div class="row g-3 needs-validation" novalidate>
                                <div class="row mt-5">
                                    <div class="col-12">
                                        <label for="" class="form-label">Company</label>
                                        <input type="text" class="form-control" v-model="user.Company">
                                    </div>
                                    <div class="col-12">
                                        <label for="" class="form-label">Name</label>
                                        <input type="text" class="form-control" v-model="user.Name">
                                    </div>
                                    <div class="col-12">
                                        <label for="" class="form-label">Position</label>
                                        <input type="text" class="form-control" v-model="user.Position">
                                    </div>
                                    <div class="col-12">
                                        <label for="" class="form-label">Contact No</label>
                                        <input type="text" class="form-control" v-model="user.Contact">
                                    </div>
                                    <div class="col-12">
                                        <label for="" class="form-label">Role</label>
                                        <input type="text" class="form-control" v-model="user.Role">
                                    </div>
                                    <div class="col-12">
                                        <label for="" class="form-label">Email Contact</label>
                                        <input type="email" class="form-control" v-model="user.Username">
                                    </div>
                                    <div class="col-12">
                                        <label for="" class="form-label">Create Password</label>
                                        <input type="password" class="form-control" v-model="user.Password">
                                    </div>
                                    <div class="col-12">
                                        <label for="" class="form-label">Confirm Password</label>
                                        <input type="password" class="form-control" v-model="user.RepeatPassword">
                                    </div>

                                </div>

                                <div class="col-12">
                                    <button class="btn btn-primary w-100" type="button" @click="register">Save</button>
                                </div>
                            </div>
                            <!------------------------------------------------------------------------------>
                        </div>
                    </div>

                </div>
            </div>


        </div>
    </div>
    </div>
    
</template>
<script>
import header from "../components/header.vue"
export default {
    name: 'register-page',
    data: function () {
        return {
            user: { Company: '', Name: '', Position: '', Contact: '',Role:'', Username: '', Password: '', RepeatPassword: '' },
        }
    },
    components: {
        'headboard': header
    },
    methods: {
        register() {
            let self = this;
            console.log("user", this.user);
            this.$vtc.vtcFetch("/Auth/Register", this.user,'API2').then(function (data) {
                console.log(data);
                self.$router.push({ path: '/index/' });
            });
        }
    }
}

</script>
<style scoped>
img.logo {
  width: 80%;
}

.imgLogin {
  width: 80%;
}
</style>